<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-card flat class="ma-0 pa-0">
          <v-card-text class="text-center ma-0 pa-0">
            <div>
              <div class="text-center" ><label class="font-weight-black blue--text text--darken-4 title">Enter a CAP ID or lastname below</label></div>
              <br />
              <div class="fldInput"><v-text-field v-model="inputValue" solo dense outlined class="ma-0 pa-0"></v-text-field></div>
              <v-btn color="blue darken-4" dark width="175" @click.native="navigateTo()">Lookup Member</v-btn><br><br>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'MemberInfoSelector',
    data () {
      return {
        search: '',
        inputValue: '',
      }
    },
    mounted() {
      this.setBackButtonVisibility(true);
      this.setHomeButtonVisibility(true);
    },
    methods: {
      navigateTo() {
        if(this.inputValue != '')
        {
          if(isNaN(this.inputValue) == true)
          {
            //console.log("/memberinfo/type/lastname/" + this.inputValue);
            this.$router.push("/memberinfo/type/lastname/" + this.inputValue)
          }
          else
          {
            //console.log("/memberinfo/type/capid/" + this.inputValue);
            this.$router.push("/memberinfo/type/capid/" + this.inputValue)
          }
        }
      }
    }
  }
</script>

<style scoped>
.fldInput {
  width: 200px;
  max-width:200px;
  margin: auto;
}
</style>
